<template>
    <div class="content-faqs container">
        <div class="content-faqs-title">
            <button tag="a" @click="hasHistory() 
                ? $router.go(-1) 
                : $router.push('/')" class="btn-return">
                <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="69" height="69" viewBox="0 0 69 69">
                    <defs>
                        <linearGradient id="linear-gradient" x1="0.5" x2="0.5" y2="1" gradientUnits="objectBoundingBox">
                        <stop offset="0" stop-color="#fece09"/>
                        <stop offset="1" stop-color="#f5891f"/>
                        </linearGradient>
                        <filter id="Ellipse_2" x="0" y="0" width="69" height="69" filterUnits="userSpaceOnUse">
                        <feOffset dy="6" input="SourceAlpha"/>
                        <feGaussianBlur stdDeviation="6" result="blur"/>
                        <feFlood flood-opacity="0.161"/>
                        <feComposite operator="in" in2="blur"/>
                        <feComposite in="SourceGraphic"/>
                        </filter>
                    </defs>
                    <g id="Group_2353" data-name="Group 2353" transform="translate(-18 -43)">
                        <g transform="matrix(1, 0, 0, 1, 18, 43)" filter="url(#Ellipse_2)">
                        <circle id="Ellipse_2-2" data-name="Ellipse 2" cx="16.5" cy="16.5" r="16.5" transform="translate(18 12)" fill="url(#linear-gradient)"/>
                        </g>
                        <path id="Union_1" data-name="Union 1" d="M11.562,0h.723V12.285h-.723V.723H0V0Z" transform="translate(55.187 79.873) rotate(-135)" fill="none" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"/>
                    </g>
                </svg>

                <h3>Perguntas frequentes</h3>
            </button>
        </div>
        <div class="accordion" role="tablist">
            <b-card no-body v-for="faq in faqs" :key="faq.id">
                <b-card-header header-tag="header" class="p-1" role="tab">
                    <b-button block v-b-toggle="'accordion-' + faq.id" variant="info">{{ faq.question }}
                        <svg xmlns="http://www.w3.org/2000/svg" width="22.348" height="22.348" viewBox="0 0 22.348 22.348">
                            <path id="Union_1_-_Outline" data-name="Union 1 - Outline" d="M13.932-.5H14.8a.5.5,0,0,1,.5.5V14.8a.5.5,0,0,1-.5.5h-.871a.5.5,0,0,1-.5-.5V1.371H0a.5.5,0,0,1-.5-.5V0A.5.5,0,0,1,0-.5Z" transform="translate(0.707 11.174) rotate(-45)" fill="#173f35"/>
                        </svg>
                    </b-button>
                </b-card-header>
                <b-collapse :id="'accordion-' + faq.id" accordion="my-accordion" role="tabpanel">
                    <b-card-body>
                        <b-card-text v-html="faq.answer" class="lineBreaks"></b-card-text>
                    </b-card-body>
                </b-collapse>
            </b-card>
        </div>
    </div>
</template>
<style lang="scss">
.lineBreaks {
    white-space: pre-line;
}
.content-faqs{
    margin: 200px auto 150px auto;
    &-title{
        margin-bottom: 30px;
        button{
            all: unset;
            display: flex;
            align-items: center;
            justify-content: flex-start;
            cursor: pointer;
            @media screen and (max-width: 991px){
                h3{
                    text-align: left;
                    width: 100%;
                }
            }
        }
    }
    .card{
        background-color: #F9F9F9;
        border: none;
        margin-bottom: 30px;
    }
    .card-header{
        border: none;
        background: transparent;
    }
    .btn-info{
        color: black;
        text-align: left;
        font-size: 18px;
        font-family: "Font Bold";
        border:none;
        background-color: #F9F9F9;
        svg{
            float: right;
            margin-top: -5px;
        }
    }
    .btn-info:focus{
        box-shadow: none;
    }
    .btn-info:hover, .btn-info:focus, .btn-info:active, .btn-info.active, .open>.dropdown-toggle.btn-info{
        background-color: #F9F9F9;
    }

    .collapsed{
        svg{
            transform: translateY(-50%) rotate(180deg);
            margin-top: 15px;
        }
    }

    .btn-info:not(:disabled):not(.disabled):active{
        background-color: #F9F9F9;
        color: black;
        border: none;
    }
    .card-body{
        p{
            font-size: 18px;
            font-family: "Font Regular";
            color: black;
            line-height: 24px;
            text-align: justify;
        }
    }
}

</style>

<script>
import axios from 'axios'

  export default {
    data() {
      return {
        faqs:''
      }
    },
    methods: {
        hasHistory() {
            return window.history.length > 1;
        }
    },
    async mounted() {
        axios.get("/api/v1/faqs")
            .then((resp) => {
                this.faqs = resp.data
            })
    }
  }
</script>